import { AreaOfInterestDto, UserAreaOfInterestItemDto } from '@/api/generated';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';

interface Props {
  activeAreaOfInterests: AreaOfInterestDto[];
  onChange: (selectedAreas: UserAreaOfInterestItemDto[]) => void;
  value?: UserAreaOfInterestItemDto[];
}

export const AreaOfInterestPrioritySelector: React.FC<Props> = ({
  activeAreaOfInterests,
  onChange,
  value = [],
}) => {
  const { t } = useTranslationWithPrefix('views.process.personalData.areasSelection');
  const [selectedAreaIds, setSelectedAreaIds] = useState<number[]>([]);

  useEffect(() => {
    if (value.length > 0) {
      const ids = value.map(item => item.areaOfInterestId);
      setSelectedAreaIds(ids);
    }
  }, [value]);

  const handleAreaToggle = (areaId: number) => {
    const newIds = selectedAreaIds.includes(areaId)
      ? selectedAreaIds.filter(id => id !== areaId)
      : selectedAreaIds.length < 3
        ? [...selectedAreaIds, areaId]
        : selectedAreaIds;

    setSelectedAreaIds(newIds);

    const selectedAreas = newIds.map((id, index) => ({
      areaOfInterestId: id,
      description: '',
      priority: index + 1,
    }));
    onChange(selectedAreas);
  };

  return (
    <div className="h-full">
      <div>
        <p className="text-gray-600">
          {t('instruction')}
          <span className="font-semibold"> {selectedAreaIds.length}/3</span>
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 items-center mt-3 md:mt-5">
        {activeAreaOfInterests.map(area => (
          <Form.Check
            checked={selectedAreaIds.includes(area.areaOfInterestId)}
            disabled={
              selectedAreaIds.length >= 3 && !selectedAreaIds.includes(area.areaOfInterestId)
            }
            id={area.areaOfInterestId.toString()}
            key={area.areaOfInterestId}
            label={area.description}
            onChange={() => handleAreaToggle(area.areaOfInterestId)}
            type="checkbox"
          />
        ))}
      </div>
    </div>
  );
};
